export default function PhilosophySection() {
  return (
    <section className="w-full flex flex-col lg:flex-row min-h-[600px]">
      <div className="lg:w-1/2 relative min-h-[400px] lg:min-h-full overflow-hidden bg-background-100">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              'url(https://readdy.ai/api/search-image?query=Minimalist%20abstract%20composition%20with%20soft%20warm%20beige%20and%20cream%20tones%2C%20fluid%20organic%20geometric%20shapes%20overlapping%20gently%2C%20subtle%20gradients%2C%20calm%20sophisticated%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20clean%20modern%20aesthetic%2C%20serene%20corporate%20art%20direction&width=800&height=800&seq=tanengata-philosophy&orientation=squarish)',
          }}
        />
        <span className="absolute top-10 left-8 md:left-14 text-foreground-500 text-xs font-semibold tracking-widest uppercase z-10">
          Philosophy
        </span>
        <h2 className="absolute bottom-10 left-8 md:left-14 font-heading text-foreground-900 text-4xl md:text-5xl font-bold leading-tight z-10 max-w-md">
          Continuous innovation
          <br />
          through disciplined
          <br />
          engineering.
        </h2>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center px-8 md:px-14 py-16 md:py-0">
        <div className="max-w-lg mx-auto lg:mx-0 text-center lg:text-left">
          <h3 className="font-heading text-foreground-900 text-3xl md:text-4xl font-bold leading-tight">
            Built for the
            <br />
            long term.
          </h3>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mt-6">
            We approach every project as a long-term investment in quality.
            Rather than chasing trends, we focus on foundational principles:
            clean, well-structured code, thoughtful system design, and
            rigorous attention to detail. This means every component is built
            to be understood, extended, and maintained by future engineers.
          </p>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mt-5">
            Our development process emphasises clarity over cleverness,
            simplicity over complexity, and reliability over rapid iteration.
            We believe great software comes from disciplined engineering, not
            shortcuts — and that philosophy shapes everything we deliver.
          </p>
        </div>
      </div>
    </section>
  );
}